import { Fragment, RefObject, useEffect, useRef } from 'react';
import { Transition } from '@headlessui/react';
import AccountMenuContent from '../../AccountMenuContent';

export default function AccountMenu({
  open,
  setOpen,
  triggerRef,
}: {
  open: boolean;
  setOpen: (state: boolean) => void;
  triggerRef?: RefObject<HTMLElement>;
}) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const onPointerDown = (event: MouseEvent) => {
      const target = event.target as Node;

      // Clicks on the trigger are handled by its own onClick (toggle), so
      // don't treat them as "outside" — otherwise it would close then reopen.
      if (
        !containerRef.current?.contains(target) &&
        !triggerRef?.current?.contains(target)
      ) {
        setOpen(false);
      }
    };

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, setOpen, triggerRef]);

  return (
    <div ref={containerRef} className="hidden lg:block">
      <Transition
        show={open}
        as={Fragment}
        enter="transition duration-150 ease-out"
        enterFrom="-translate-y-1 opacity-0"
        enterTo="translate-y-0 opacity-100"
        leave="transition duration-100 ease-in"
        leaveFrom="translate-y-0 opacity-100"
        leaveTo="-translate-y-1 opacity-0"
      >
        <div className="absolute right-1/2 top-[42px] z-50 w-[200px] translate-x-1/2 border bg-white">
          <AccountMenuContent
            closeModal={() => setOpen(false)}
            isMobile={false}
          />
        </div>
      </Transition>
    </div>
  );
}
